import styled from "styled-components";

export const StyledButton = styled("button") <{ color?: string }>`
  background: ${(p) => p.color || "#FFBF00"};
  color: #000000;
  font-size: 1rem;
  font-weight: 600;
  width: 100%;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 14px 28px;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 320px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 4px 12px rgba(255, 191, 0, 0.2);

  &:hover,
  &:active,
  &:focus {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 191, 0, 0.3);
    background: ${(p) => p.color || "#E6AC00"};
  }
`;
